import React, {useState, useRef, useCallback} from "react"
import ReCAPTCHA from "react-google-recaptcha"
import axios from "axios"
import "./contactForm.css"

const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY || "6Leml6ssAAAAAGpGkaRh6pdK1U5S9GMrMikSXulp"

const ContactFormPro = ({showMpInfo = true}) => {
    const recaptchaRef = useRef(null)

    const [form, setForm] = useState({
        fname: "",
        lname: "",
        email: "",
        phone: "",
        message: "",
    })
    const [captchaToken, setCaptchaToken] = useState(null)
    const [status, setStatus] = useState({type: "", text: ""})
    const [loading, setLoading] = useState(false)

    const handleChange = (e) => {
        const {name, value} = e.target
        setForm((prev) => ({...prev, [name]: value}))
    }

    const onCaptchaChange = useCallback((token) => {
        setCaptchaToken(token)
    }, [])

    const onCaptchaExpired = useCallback(() => {
        setCaptchaToken(null)
    }, [])

    const handleSubmit = async (e) => {
        e.preventDefault()

        if (!captchaToken) {
            setStatus({type: "error", text: "Veuillez valider le captcha avant d'envoyer."})
            return
        }

        if (!form.lname || !form.email) {
            setStatus({type: "error", text: "Veuillez renseigner au minimum votre nom et votre email professionnel."})
            return
        }

        setLoading(true)
        setStatus({type: "", text: ""})

        try {
            const payload = {
                email: form.email,
                fname: form.fname,
                lname: form.lname,
                phone: form.phone,
                message: form.message,
                captchaToken,
            }

            const response = await axios.post(
                "https://ekrak.com/api/email/sendmessage",
                payload,
                {headers: {"Content-Type": "application/json"}}
            )

            if (response.data === 1 || response.status === 200) {
                setStatus({
                    type: "success",
                    text: "Votre message a été envoyé avec succès. Nous vous répondrons très vite !",
                })
                setForm({fname: "", lname: "", email: "", phone: "", message: ""})
                if (recaptchaRef.current) recaptchaRef.current.reset()
                setCaptchaToken(null)
            } else {
                setStatus({
                    type: "error",
                    text: "Un problème est survenu, veuillez réessayer ultérieurement.",
                })
            }
        } catch (err) {
            setStatus({
                type: "error",
                text: "Erreur lors de l'envoi. Vérifiez votre connexion et réessayez.",
            })
        } finally {
            setLoading(false)
        }
    }

    return (
        <section className="contact-section" id="section_contact">
            <div className="contact-container">
                <div className="contact-info">
                    <h2 className="contact-title">Parlons entre professionnels</h2>
                    <p className="contact-subtitle">
                        Une question, un partenariat ou simplement envie d'en savoir plus ?
                        Écrivez-nous, notre équipe vous répond sous 24h/48h.
                    </p>

                    <div className="contact-details">
                        <h5>Directement par mail :</h5>
                        <div className="contact-detail-item">

                            <span className="contact-icon">🏢</span>
                            <div>
                                <strong>Professionnels</strong>
                                <a href="mailto:partners@justnow.app">partners@justnow.app</a>
                            </div>
                        </div>
                        <h5>Ou à l'aide de notre formulaire :</h5>
                    </div>

                    {showMpInfo && (
                            <p className="contact-pro-note">
                                Vous gérez plusieurs établissements : nous avons conçu<a href="/grands-comptes"> un <strong>gestionnaire de grands comptes</strong> </a> adapté
                                à votre structure.{" "}
                            </p>
                    )}

                    <div className="contact-form-wrapper">
                        <form className="contact-form" onSubmit={handleSubmit} noValidate>
                            <div className="form-row">
                                <div className="form-field">
                                    <label htmlFor="fname">Prénom</label>
                                    <input
                                        id="fname"
                                        name="fname"
                                        type="text"
                                        placeholder="Jean"
                                        value={form.fname}
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className="form-field">
                                    <label htmlFor="lname">
                                        Nom <span className="required">*</span>
                                    </label>
                                    <input
                                        id="lname"
                                        name="lname"
                                        type="text"
                                        placeholder="Dupont"
                                        value={form.lname}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                            </div>

                            <div className="form-row">
                                <div className="form-field">
                                    <label htmlFor="email">
                                        Email <span className="required">*</span>
                                    </label>
                                    <input
                                        id="email"
                                        name="email"
                                        type="email"
                                        placeholder="jean@masociété.fr"
                                        value={form.email}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                                <div className="form-field">
                                    <label htmlFor="phone">Téléphone</label>
                                    <input
                                        id="phone"
                                        name="phone"
                                        type="tel"
                                        placeholder="+33 6 12 34 56 78"
                                        value={form.phone}
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>

                            <div className="form-field full-width">
                                <label htmlFor="message">Message</label>
                                <textarea
                                    id="message"
                                    name="message"
                                    placeholder="Décrivez votre demande et indiquez le nombre d'établissements que vous gérez..."
                                    rows="5"
                                    value={form.message}
                                    onChange={handleChange}
                                />
                            </div>

                            <div className="captcha-wrapper">
                                <ReCAPTCHA
                                    ref={recaptchaRef}
                                    sitekey={RECAPTCHA_SITE_KEY}
                                    onChange={onCaptchaChange}
                                    onExpired={onCaptchaExpired}
                                    hl="fr"
                                />
                            </div>

                            {status.text && (
                                <div className={`form-status ${status.type}`}>
                                    {status.text}
                                </div>
                            )}

                            <button
                                type="submit"
                                className="submit-btn"
                                disabled={loading || !captchaToken}
                            >
                                {loading ? (
                                    <span className="btn-loading">
                  <span className="spinner"/>
                  Envoi en cours...
                </span>
                                ) : (
                                    "Envoyer le message"
                                )}
                            </button>
                        </form>
                    </div>
                </div>

            </div>
        </section>
    )
}

export default ContactFormPro
